
import Connection from '../services/Connection';
import Model from '../models/model';
import util from '../util';

const loadOperators = ({ keyword }) => {
	const api = Connection.Combo
	const formData = util.getDefaultComboParams('Operator', keyword)
	return fetch(api, { method: 'POST', body: formData }).then(res => res.json()).then(({ records, success }) => {
		const options = Array.isArray(records) ? records.map(({ LookupId, DisplayValue, ...rest }) => ({ ...rest, id: LookupId, label: DisplayValue })) : []
		return { options, count: options.length }
	});
}


const onCreateOption = (value) => {
	const formData = new FormData();
	formData.append('start', 0);
	formData.append('comboType', 'Operator');
	formData.append('search', value.option.id);
	formData.append('asArray', 0);
	formData.append('limit', 50);
	try {
		fetch(Connection.Combo, {
			method: 'POST',
			body: formData,
			credentials: 'include'
		})
	} catch (error) {
		console.error('Error creating record:', error);
	}
}
const model = new Model({
	name: 'Cycle',
	api: 'Cycle',
	title: 'Cycle',
	showGridRefreshBtn: true,
	disableDelete: true,
	columns: [
		{
			header: 'OperatorName', field: 'OperatorName', lookup: loadOperators, freeSolo: true, filterMode: 'server', onCreateOption, autocompleteValueFormatter: (value) => (value ? value.label : "")
		}
	]
});
export const OperatorNameModel = model;
export default model.createFormBase();
